// @ts-strict

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { isUndefined } from 'lodash';
import { IOrderedTraslantedCountry } from '../countries-checkbox-list.component';

export interface CheckedCountryData {
  checkedCountry: IOrderedTraslantedCountry;
  isChecked: boolean;
}

@Component({
  selector: 'app-country-checkbox',
  templateUrl: './country-checkbox.component.html',
  styleUrls: ['./country-checkbox.component.scss']
})
export class CountryCheckboxComponent {
  @Input() country?: IOrderedTraslantedCountry;
  @Input() defaultValue?: string;
  @Input('checkedValues') checkedCountries: any[] = [];
  @Input() hide?: boolean;
  @Output() emitCheckedCountry = new EventEmitter<CheckedCountryData>();

  public checkedCountry = false;

  public toggleCountry(): void {
    if (this.country) {
      this.checkedCountry = !this.checkedCountry;
      this.emitCheckedCountry.emit({ checkedCountry: this.country, isChecked: this.checkedCountry });
    }
  }

  public isCountryChecked(countryName?: string): boolean {
    if (isUndefined(countryName)) return false;

    return this.checkedCountries.some(country => country === countryName);
  }
}
